'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'ProjectRestService',
    function($modal, ProjectRestService) {
        return {
            select: select,
            create: create,
            edit: edit,
            remove: remove,
            api: ProjectRestService,
        };

        // region Function

        function select(projectMaintenance, projectMaintenances) {
            return $modal.open({
                template: require('../view/project-maintenance-modal-select.html'),
                controller: 'ProjectMaintenanceModalSelectController',
                size: 'md',
                backdrop: false,
                resolve: {
                    projectMaintenance: function() {
                        return projectMaintenance;
                    },
                    projectMaintenances: function() {
                        return projectMaintenances;
                    },
                },
            });
        }

        function create(def, edit, projectMaintenances, project) {
            return $modal.open({
                template: require('../view/project-maintenance-modal-create.html'),
                controller: 'ProjectMaintenanceModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    maintenance: function() {
                        return def;
                    },
                    edit: function() {
                        return edit;
                    },
                    projectMaintenances: function() {
                        return projectMaintenances;
                    },
                    project: function () {
                        return project;
                    },
                    partialEdit: function() {
                        return null;
                    },
                    showPartial: function() {
                        return null;
                    },
                    cancelPartial: function() {
                        return null;
                    },
                    editingPartial: function() {
                        return null;
                    },
                    savePartial: function() {
                        return null;
                    }
                },
            });
        }

        function edit(maintenance, edit, projectMaintenances, project, partialEdit, showPartial, cancelPartial, editingPartial, savePartial) {
            return $modal.open({
                template: require('../view/project-maintenance-modal-create.html'),
                controller: 'ProjectMaintenanceModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    maintenance: function() {
                        return maintenance;
                    },
                    edit: function() {
                        return edit;
                    },
                    projectMaintenances: function() {
                        return projectMaintenances;
                    },
                    project: function () {
                        return project;
                    },
                    partialEdit: function() {
                        return partialEdit;
                    },
                    showPartial: function() {
                        return showPartial;
                    },
                    cancelPartial: function() {
                        return cancelPartial;
                    },
                    editingPartial: function() {
                        return editingPartial;
                    },
                    savePartial: function() {
                        return savePartial;
                    }
                },
            });
        }

        function remove(project, callback) {
        }

        // endregion
    }];
